
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="身份证号">
              <a-textarea
                v-model="queryParam.nums"
                allowClear
                placeholder="身份证换行隔开"
              />
            </a-form-item>
          </a-col>
           
          <a-col :md="(!advanced && 6) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="
                (advanced && { float: 'right', overflow: 'hidden' }) || {}
              "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => (queryParam = {})"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button @click="download()">
        导出
        <a-icon type="download" />
      </a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{
        show: true,
        clear: () => {
          this.selectedRowKeys = [];
        },
      }"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <span slot="danwei" slot-scope="text, record">
        <div style="margin-left: 10px; float: left">
          {{ record.name }}  
          <br />
          {{ record.num }}
          <br />  
        </div>
      </span>
      <span slot="grade1" slot-scope="text, record">  
        <p  >{{ record.kg }}</p> 
        注册时间: {{record.kg_date|timeFormat}}
      </span>   
      <span slot="grade2" slot-scope="text, record">  
        <p  >{{ record.jd }}</p> 
        注册时间: {{record.jd_date|timeFormat}}
      </span>   
      <span slot="grade3" slot-scope="text, record">  
        <p  >{{ record.ds }}</p> 
        注册时间: {{record.ds_date|timeFormat}}
      </span>   
      <span slot="grade4" slot-scope="text, record">  
        <p  >{{ record.pxs }}</p> 
        注册时间: {{record.pxs_date|timeFormat}}
      </span>   
    </s-table>
 
  </a-card>
</template>

<script>
import STable from "@/components/table/";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AInput from "ant-design-vue/es/input/Input";
import EditableCell from "@/components/EditableCell/";
import PicUploader from "@/components/PicUploader/";
import FileUploader from "@/components/FileUploader/";
import JiaolianPicker from "@/components/JiaolianPicker/";
import CaipanPicker from "@/components/CaipanPicker/";
import areaOptions from "@/utils/area";
// import xlsx from "@/utils/xlsx";
import XLSX from 'xlsx'
import moment from "moment";
import qs from "qs";
import setting from "@/config/setting"; 
import "moment/locale/zh-cn";

moment.locale("zh-cn");

import {
  kgjdgradelist, 
} from "@/api/cha";

export default {
  name: "KaojiApplyList",
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    EditableCell,
    CaipanPicker,
    JiaolianPicker,
  },
  data() {
    return {
      areaOptions,
      visible: false,
      orderVisible: false,
      saveLoading: false,
      userFormVisible: false,
      jiaolianPickerShow: false,
      caipanPickerShow: false,
      sjsqOptions: [],
      orderFormData: {},
      formData: {
        id: 0,
        danwei: "",
        areas: [],
        member_list: [],
        loglist: [],
      },
      time_range_moment: [],
      time_range: [],
      labelCol: {
        //          xs: { span: 24 },
        //          sm: { span: 5 },
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: this.$form.createForm(this),
      form3: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: "",
        sjsq: [],
      },
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "人员信息",
          dataIndex: "danwei",
          scopedSlots: { customRender: "danwei" },
        },
        {
          title: "考官等级",
          dataIndex: "jl",
          scopedSlots: { customRender: "grade1" },
        },
        {
          title: "监督等级",
          dataIndex: "jd",
          scopedSlots: { customRender: "grade2" },
        },  
        {
          title: "导师等级",
          dataIndex: "ds",
          scopedSlots: { customRender: "grade3" },
        },  
        {
          title: "培训师等级",
          dataIndex: "pxs",
          scopedSlots: { customRender: "grade4" },
        },  
      ],
      // 表头
      subjectColumns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "姓名",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "电话",
          dataIndex: "phone",
        },
        {
          title: "微信",
          dataIndex: "weixin",
        },
        {
          title: "套餐",
          dataIndex: "service",
          scopedSlots: { customRender: "service" },
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 120,
          scopedSlots: { customRender: "action" },
        },
      ],
      listData:[],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log("loadData");
        console.log(this.queryParam);
        let that = this;
 

        this.queryParam = Object.assign(this.queryParam, parameter);
        return kgjdgradelist(this.queryParam).then((res) => {
          console.log("res");
          that.listData = res.data.list
          return res.data;
        });
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: "",
        price: 0,
        note: "",
        count: 0,
      },
      serviceTypeOptions: [],
      userFormData: {
        id: 0,
        name: "",
        caipandengjiwudao: "",
        caipandengjijiqiao: "",
        jiaoliandengjiwudao: "",
        jiaoliandengjijiqiao: "",
        caipanshenbaowudao: "",
        caipanshenbaojiqiao: "",
        jiaolianshenbaowudao: "",
        jiaolianshenbaojiqiao: "",
      },
    };
  },
  computed: {},

  created() {},

  mounted() {
    let that = this;

    let query = this.$route.query;
    // 6, 276
    console.log(query);
    if (query.saiji) {
      this.queryParam.sjsq = [query.saiji, query.saiqu];
    }
    // that.getSjsqOptions();
  },
  methods: {
    moment,
    getSjsqOptions() {
      let that = this;
      sjsqOptions({}).then((res) => {
        that.sjsqOptions = res.data;
      });
    },
    handleCancel() {
      this.visible = false;
    },
    handleOrderCancel() {
      this.orderVisible = false;
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    handlePrint(record) {
      let self = this;
      shengCaipanPrint({ id: record.id })
        .then((res) => {
          self.$message.success("打印成功");
        })
        .catch((err) => {
          console.log(err);
          self.$message.error(err.data.msg);
        });
    },

    handleEdit(record) {
      let self = this;
      this.visible = true;
      getShengCaipanDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form.setFieldsValue({ ...res.data });
          self.formData.id = record.id;
          console.log("handleEdit");
          // if(res.data.area){
          //   res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
          // }else{
          //   res.data.areas = [];
          // }
          res.data.regist_date = moment(res.data.regist_date * 1000).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          res.data.regist_date = moment(res.data.regist_date, "YYYY-MM-DD");
          self.formData = { ...res.data };
        }, 200);
      });
      // console.log(this.mdl)
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false);
    },

    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault();

      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.formData);
          self.saveLoading = true;
          editShengCaipan({
            id: self.formData.id,
            name: self.formData.name,
            weixin: self.formData.weixin,
            email: self.formData.email,
            num: self.formData.num,
            phone: self.formData.phone,
            code: self.formData.code,
            regist_date: parseInt(
              moment(self.formData.regist_date).valueOf() / 1000
            ),
            wudaograde: self.formData.wudaograde,
          })
            .then((res) => {
              self.$message.success("修改成功");
              self.$refs.table.refresh(false);
              self.visible = false;
              self.saveLoading = false;
            })
            .catch((err) => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            });
        }
      });
    },
    // 增改 处理
    handleOrderOk(e) {
      let self = this;
      e.preventDefault();

      self.saveLoading = true;
      editShengCaipanOrder({
        id: self.orderFormData.id,
        baoming_id: self.orderFormData.baoming_id,
        status: self.orderFormData.status,
        adminnote: self.orderFormData.adminnote,
        memberprice: self.orderFormData.memberprice,
        pay_price: self.orderFormData.pay_price,
      })
        .then((res) => {
          self.$message.success("修改成功");
          self.$refs.table.refresh(false);
          self.orderVisible = false;
          self.saveLoading = false;
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
          self.saveLoading = false;
        });
    },

    handleDelete(record) {
      let that = this;
      deleteShengCp({
        id: record.id,
      })
        .then((res) => {
          that.$message.success("删除成功");
          that.$refs.table.refresh(false);
        })
        .catch((err) => {
          that.$message.error(err.data.msg);
        });
    },

    // 删
    applyDelete(record) {
      let self = this;
      applyDelete({ id: record.id })
        .then((res) => {
          self.$message.success("删除成功");
          self.$refs.table.refresh();
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    // 删
    applyDeleteAll() {
      let self = this;
      applyDelete({ ids: self.selectedRowKeys, id: 0 })
        .then((res) => {
          self.$message.success("删除成功");
          self.$refs.table.refresh();
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },

    onEditUser(record) {
      let self = this;
      this.userFormVisible = true;
      getApplyUserDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form3.setFieldsValue({ ...res.data });
          self.userFormData.id = record.id;
          self.userFormData = { ...res.data };
        }, 200);
      });
      getServiceTypeList({ saiqu: self.formData.saiqu }).then((res) => {
        setTimeout(() => {
          self.serviceTypeOptions = res.data;
        }, 200);
      });
    },
    handleUserFormCancel() {
      this.userFormVisible = false;
    },

    handleUserFormOk(e) {
      let self = this;
      e.preventDefault();
      this.form3.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.userFormData);
          self.saveLoading = true;
          editShengCaipanUser({
            id: self.userFormData.id,
            name: values.name,
            num: values.num,
            phone: values.phone,
            sex: values.sex,
            service_id: self.userFormData.service_id,
            caipandengjiwudao: self.userFormData.caipandengjiwudao,
            caipandengjijiqiao: self.userFormData.caipandengjijiqiao,
            jiaoliandengjiwudao: self.userFormData.jiaoliandengjiwudao,
            jiaoliandengjijiqiao: self.userFormData.jiaoliandengjijiqiao,
            caipanshenbaowudao: self.userFormData.caipanshenbaowudao,
            caipanshenbaojiqiao: self.userFormData.caipanshenbaojiqiao,
            jiaolianshenbaowudao: self.userFormData.jiaolianshenbaowudao,
            jiaolianshenbaojiqiao: self.userFormData.jiaolianshenbaojiqiao,
          })
            .then((res) => {
              self.$message.success("修改成功");
              self.userFormVisible = false;
              self.saveLoading = false;
            })
            .catch((err) => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            });
        }
      });
    },

    download() {
        let fields = {
            title0: "序号",
            title1: "姓名",
            title2: "数量",
          };


        let arry = [
          {
            title0: "11",
            title1: "22",
            title2: "33",
          }
        ]; 
        // xlsx(arry, fields, "excel统计列表");
        if(this.listData.length==0){
          return this.$message.error("数据为空");
        }
        let _data = [[ "序号","姓名", "身份证号码","考官等级","考官注册时间",'监督等级','监督注册时间' ,'导师等级','导师注册时间' ,'培训师等级','培训师注册时间' ]];
        this.listData.map((item,index)=>{
          _data.push([
            index+1,
            item.name,
            item.num,
            item.kg,
            item.kg_date_str,
            item.jd,
            item.jd_date_str,
            item.ds,
            item.ds_date_str,
            item.pxs,
            item.pxs_date_str,
          ]);
        });
        const ws= XLSX.utils.aoa_to_sheet(_data); 
        /* generate workbook and add the worksheet */
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '考官监督导师培训师等级查询结果');
        /* save to file */
        XLSX.writeFile(wb, '考官监督导师培训师等级查询结果.xlsx');
    },
    downloadCert(record) {
      window.open(setting.apiBaseURL + "" + record.cert_url);
    },
    refreshCert(record) {
      const hide = this.$message.loading("生成中..", 0);
      refreshCert({ id: record.id }).then((res) => {
        this.$message.success("证书生成成功");
        setTimeout(hide, 0);
      });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
  },
  filters: {},
  watch: {},
};
</script>
